import {
  Product,
  SoftwareApplication,
  Offer,
  PriceSpecification,
} from 'schema-dts';
import { siteUrl } from '../..';
import { mapperOffer } from 'apps/website/src/components/BlockComponents/TablePriceBlockComponent/scripts/mappers/mapperOffer';
import { formatPrice } from 'apps/website/src/utils/formatPrice';
import { SiteLocale } from 'apps/website/types/dato';

type ImergeLocalSchema = Omit<
  Partial<SoftwareApplication> & Partial<Product>,
  '@type'
> & {
  '@type': string | string[];
};

export const tablePrices = (
  data: any,
  uri: string,
  localeSlug: SiteLocale,
  currencyObject: { code: string; symbol: string },
): any => {
  const description = data?.metaFields?.description;
  const newType = ['Product', 'SoftwareApplication'];

  const labels = data?.tablePrice?.labels;
  const offers: any[] = [];
  data?.tablePrice?.offers?.forEach((_offer: any) => {
    const offer = mapperOffer(_offer, localeSlug);
    offer.pricingRange.forEach((priceRange: any) => {
      const isOnDemand = priceRange.onDemand;

      const priceSpec: PriceSpecification = {
        '@type': 'PriceSpecification',
        priceCurrency: currencyObject.code,
        description: priceRange.priceLabel,
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          minValue: priceRange.from,
          maxValue: priceRange.to || undefined,
        },
      };
      if (isOnDemand) {
        priceSpec.description = labels.onDemandTitleLabel || 'Price on request';
      } else {
        priceSpec.price = priceRange.price.toString();
        priceSpec.description = `${formatPrice(priceRange.base, localeSlug)} ${labels.baseLabel}, ${formatPrice(priceRange.price, localeSlug)} ${labels.priceLabel}`;
      }
      let employeeLabel = 'employees';
      if (localeSlug === 'fr') {
        employeeLabel = 'collaborateurs';
      }
      if (localeSlug === 'en') {
        employeeLabel = 'empleados';
      }
      const __offer: any = {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: `${offer.title} (${priceRange.from}-${priceRange.to} ${employeeLabel})`,
        },
        name: `${offer.title} (${priceRange.from}-${priceRange.to} ${employeeLabel})`,
        description: isOnDemand
          ? `${labels.basePriceLabel} - ${labels.onDemandTitle} ${labels.pricePerEmployeeLabel}`
          : `${labels.basePriceLabel} - ${labels.basePrice} ${currencyObject.code} ${labels.pricePerEmployeeLabel}`,
        priceSpecification: priceSpec,
      };
      offers.push(__offer);
    });
  });

  const product: ImergeLocalSchema = {
    '@type': newType,
    '@id': `${siteUrl}${uri}#product`,
    mainEntityOfPage: { '@id': `${siteUrl}${uri}` },
    name: 'Payfit App',
    brand: { '@id': `${siteUrl}/${localeSlug}#organization` },
    description: description || '',
    operatingSystem: 'Payfit',
    applicationCategory: 'Application',
    manufacturer: { '@id': `${siteUrl}/${localeSlug}#organization` },
    logo: {
      '@id': 'https://payfit.com/fr/#/schema/logo/image/',
    },
    image: {
      '@id': `${siteUrl}${uri}#primaryimage`,
    },
    offers,
  };
  return product;
};
